import type { EventPlayerTeam } from '../types/eventTeam';

/**
 * The teams a saved check lists for running. A check linked to an event lists
 * only that event's teams, even before any are linked, since every team from
 * every past event is a long scroll; any other team is one toggle away. Ticked
 * teams always stay listed, so nothing runs out of sight.
 */
export function checkTeamList(
  teams: EventPlayerTeam[],
  options: { eventId: string | null; showAll: boolean; selected: ReadonlySet<string>; query: string },
): { eventTeamCount: number; listingEventTeams: boolean; visible: EventPlayerTeam[] } {
  const { eventId, showAll, selected } = options;
  const eventTeamCount = eventId ? teams.filter((t) => t.event_id === eventId).length : 0;
  const listingEventTeams = eventId != null && !showAll;
  const scoped = listingEventTeams ? teams.filter((t) => t.event_id === eventId || selected.has(t.id)) : teams;
  const query = options.query.trim().toLowerCase();
  return { eventTeamCount, listingEventTeams, visible: query ? scoped.filter((t) => t.name.toLowerCase().includes(query)) : scoped };
}
